import { Dialog, DialogActions, DialogContent, DialogTitle, Button, CircularProgress } from '@mui/material'
import Text from 'Components/Ui-Kits/Text'
import { bool, func, string } from 'prop-types'
import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

export const PreviewConfirm = ({ title, open, onClose, getPreview, onConfirm }) => {
  const [loading, setLoading] = useState(true)
  const { t } = useTranslation()
  const iframeRef = useRef()
  const [subject, setSubject] = useState('')
  const [to, setTo] = useState('')

  useEffect(() => {
    if (!open) return

    setLoading(true)
    getPreview()
      .then(({ data }) => {
        if (!iframeRef.current) return

        let y = iframeRef.current.contentWindow || iframeRef.current.contentDocument
        if (y.document) y = y.document

        let frame = iframeRef.current.contentWindow || iframeRef.current.contentDocument
        if (frame.document) frame = frame.document

        frame.open()
        frame.write(data.body)
        setSubject(data.subject)
        setTo(data.to)
        frame.close()
      })
      .finally(() => setLoading(false))
  }, [open, getPreview])

  return (
    <Dialog
      maxWidth="lg"
      onClose={onClose}
      open={open}
      fullWidth
      PaperProps={{ style: { height: '90%', minHeight: 400, display: 'flex' } }}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent sx={{ flex: 1, display: 'flex', flexDirection: 'column', position: 'relative' }}>
        <div>
          <Text>
            <b>{t('subject')}:</b> {subject},&nbsp;&nbsp;<b>{t('to')}:</b> {to}
          </Text>
        </div>
        <Iframe frameBorder="0" ref={iframeRef} />
        {loading && (
          <LoadingWrap>
            <CircularProgress />
          </LoadingWrap>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('cancel')}</Button>
        <Button variant="contained" color="success" disabled={loading} onClick={onConfirm}>
          {t('send')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

PreviewConfirm.propTypes = {
  title: string.isRequired,
  getPreview: func.isRequired,
  onConfirm: func.isRequired,
  onClose: func.isRequired,
  open: bool.isRequired,
}

const Iframe = styled.iframe`
  flex: 1;
  padding: 0;
  margin: 0;
`

const LoadingWrap = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  background-color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`
